import React, { useState, useContext } from 'react';
import { RouteComponentProps } from '@reach/router';
import { Header } from '../Header';
import { StyledLayout, StyledContent } from '../Styled';
import { TrialAccessBanner } from '../TrialAccessBanner';
import { Footer } from '../Footer/Footer';
import { TermsOfUseModal } from '../Modal';
import AuthContext from '../../contexts/authContext';
import { UndoRedoProvider } from '../../contexts/undoRedoContext';
import { EditToolContextProvider } from '../../contexts/editToolContext';
import { ProformaContextProvider } from '../../contexts/proformaContext';

export const Layout: React.FC<RouteComponentProps> = (props): JSX.Element => {
  const { children, location } = props;

  const [isModalOpened, setIsModalOpened] = useState(false);

  const { isTrialAccess } = useContext(AuthContext);
  const isFullScreen = location?.pathname.includes('full-screen');

  return (
    <UndoRedoProvider>
      <ProformaContextProvider>
        <EditToolContextProvider>
          <StyledLayout>
            {isTrialAccess && <TrialAccessBanner />}
            {!isFullScreen && <Header />}
            <StyledContent withBanner={isTrialAccess}>{children}</StyledContent>
            {!isFullScreen && <Footer location={location} setIsTermsOfUseModalOpened={setIsModalOpened} />}
            {isModalOpened && (
              <TermsOfUseModal
                onClose={() => {
                  setIsModalOpened(false);
                }}
              />
            )}
          </StyledLayout>
        </EditToolContextProvider>
      </ProformaContextProvider>
    </UndoRedoProvider>
  );
};
